import React from 'react';
import { Route, IndexRoute } from 'react-router';
import UserEarnedPoints from './userEarnedPoints';

export default (
  <Route path="user-earned-points">
    <IndexRoute component={(props) => <UserEarnedPoints {...props} />} />
  </Route>
);
